import { render } from "./save-dialog.vue?vue&type=template&id=67f1905a"
import script from "./save-dialog.vue?vue&type=script&lang=js"
export * from "./save-dialog.vue?vue&type=script&lang=js"

import "./save-dialog.vue?vue&type=style&index=0&id=67f1905a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-search-bar/save-dialog.vue'],['render',render],['__file',"save-dialog.vue"]])

export default __exports__